import { InquiryUser } from './inquiry-user'
import { ListingInquiry } from './listing-inquiry'

export enum RentalInquiryStatus {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  DROPPED = 'DROPPED',
}

export type RentalInquiry = {
  id: string
  user: InquiryUser
  listingInquiries: Omit<ListingInquiry, 'user' | 'booking'>[]
  status: RentalInquiryStatus
}
